export default {
    createExam: '/newExam/create',
    getExams: '/newExam/getExams',
    getAssignmentForFacultyForSubject: '/newExam/getAssignmentForFacultyForSubject',
    getExam: '/newExam/getExam',
    getExamsFromSubjectIds: '/newExam/getExamsFromSubjectIds',
    deleteExam: '/newExam/deleteExam'
}
